import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const CtaBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
    <div className='container flex flex-col items-center justify-center mb-12 max-w-7xl'>
      <h2 className='pt-10 mb-5 text-2xl font-bold text-center md:text-3xl'>{t('how-active-customer.Veelgestelde vragen')}</h2>
      <Accordion type='single' className='w-full max-w-5xl'>
        <AccordionItem value='item-1'>
          <AccordionTrigger>{t('how-active-customer.Mijn klant maakt zijn facturen op papier')}</AccordionTrigger>
          <AccordionContent>
            <p>{t('how-active-customer.Om de klant op het Peppol-netwerk te registeren')}</p>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value='item-2'>
          <AccordionTrigger>{t('how-active-customer.Ik ben niet technisch genoeg aangelegd om mijn klanten met Peppol op weg te helpen')}</AccordionTrigger>
          <AccordionContent>
            <p>{t('how-active-customer.Hierin kunnen we gerust een adviseren en technische rol opnemen')}</p>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>

    <div className="px-4 py-4 text-white bg-gray-800 md:flex-row md:py-6 md:px-12 lg:px-24 xl:px-32">
      <div className='mx-auto md:container md:flex md:justify-between'>
        <div className="text-lg text-white md:text-xl lg:text-2xl">{t('Boekhouders.Cta.Title')}</div>
        <a href="/Contact" className="px-5 py-3 mt-2 mr-2 font-bold text-white md:mt-0 md:mr-0 bg-legoOrange hover:text-white hover:bg-legoOrange">
          {t('Boekhouders.Cta.Button')}
        </a>
      </div>
    </div>

    </>
  );
};

export default CtaBanner;
